import { z } from 'zod'

import { Ticket } from './Ticket'

export const CompletedTicketsByArea = z.object({
  content: z.array(Ticket),
  size: z.number(),
  totalElements: z.number(),
  totalPages: z.number(),
  page: z.number()
})

export const CompletedTicketOptions = z.object({
  page: z.number().optional(),
  size: z.number().optional()
})

export type CompletedTicketsByArea = z.infer<typeof CompletedTicketsByArea>
export type CompletedTicketOptions = z.infer<typeof CompletedTicketOptions>
